import React from 'react'
import tncData from '../../utils/data/tnc.json'
import clsx from 'clsx';
import styles from './tnc.module.css';
import globalStyles from '../../styles/referral/global.module.css';
import RefPendHeader from '../../components/Header/RefPend';
import useExtraFunctions from '../../hooks/useExtraFunctions';

export default function TermsAndConditions() {
    const { tnc } = tncData;
    const { changeDangerousHTMLWithoutPreHtml } = useExtraFunctions();

   
  return (
    <>
        <div className={clsx(globalStyles.container)}>
        <RefPendHeader sticky={false} title="Terms and Conditions" bgcolor="#ffffff"/>
            <div className={clsx(styles.containerInner, globalStyles.ptbl12, globalStyles.gredintbox)}>
            {
            tnc.map((item:any, index:number) => (
                <div key={index} className={clsx(styles.containerInnerItem, globalStyles.tncItem)}>
                    {changeDangerousHTMLWithoutPreHtml({ html: item['text'], tag: item['tag'] })}
                </div>
            ))
            }
            </div>
        </div>
    </>
  )
}
